import React, { useState, useEffect } from "react";
import {
  Outlet,
  useLocation,
  useNavigate,
  useOutletContext,
  useParams,
} from "react-router";
import { useDispatch } from "react-redux";
import BoxLayout from "../../../../components/Common/BoxLayout/BoxLayout";
import { addGroupTopic } from "../../../../utils/mainTabs/organize/addGroupTopic";
import {
  availableTopicActionHandler,
  getGroupTopicByIDActionHandler,
} from "../../../../store/actions/actionHandlers/organizeActionHandler";

const CreateGroupTopic = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const routerParams = useParams();
  const [dataForUpdateGroupTopicByID, setDataForUpdateGroupTopicByID] =
    useState([]);
  const [pathType, setPathType] = useState("");

  const { tiles: groupTpcTiles } = addGroupTopic;
  const {
    groupTopicTiles,
    setGroupTopicTiles,
    // seriesMgmtTiles,
    createGroupTopicPath,
    createGroupTopicEditPath,
    tenantName,
  } = useOutletContext();
  const [formData, setFormData] = useState({
    details: {
      name: "",
      UserGroupDetails: [],
      description: "",
      thumbnailImageFile: [],
    },
    topicContent: {
      TopicCourseAssociations: [],
    },
  });
  useEffect(() => {
    if (location.pathname == createGroupTopicPath) {
      let tilesList = groupTpcTiles(
        navigate,
        location,
        routerParams,
        tenantName
      );
      setGroupTopicTiles(tilesList);
      navigate(`${location.pathname}/details`);
    } else if (
      location.pathname.includes(createGroupTopicPath) &&
      groupTopicTiles.length === 0
    ) {
      navigate(createGroupTopicPath);
    }
  }, [
    location,
    location?.pathname,
    createGroupTopicPath,
    routerParams,
    dispatch,
    navigate,
    groupTpcTiles,
    groupTpcTiles?.length,
    setGroupTopicTiles,
    groupTopicTiles.length,
    tenantName,
  ]);
  const [getAllTopics, setGetAllTopics] = useState([]);
  useEffect(() => {
    if (getAllTopics?.length == 0) {
      dispatch(availableTopicActionHandler("", 0, 8, setGetAllTopics));
    }
    // setSelectedTopicData([]);
  }, [dispatch, getAllTopics?.length]);
  useEffect(() => {
    if (routerParams?.groupTopicID) {
      dispatch(getGroupTopicByIDActionHandler(routerParams?.groupTopicID)).then(
        (response) => {
          if (response) {
            setPathType("edit");
            setDataForUpdateGroupTopicByID(response?.data);
            setFormData(() => {
              return {
                details: {
                  name: response?.data?.[0]?.Name,
                  UserGroupDetails:
                    response?.data?.[0]?.GroupTopicUsergroupAssociations?.map(
                      (val) => ({
                        Name: val?.Name,
                        UserGroupId: val?.UsergroupId,
                      })
                    ),
                  description: response?.data?.[0]?.Description,
                  thumbnailImageFile: response?.data?.[0]?.ImageUrl,
                },
                topicContent: {
                  TopicCourseAssociations:
                    response?.data?.[0]?.GroupTopicSubTopicAssociations,
                },
              };
            });
          }
        }
      );
    }
  }, [dispatch, routerParams?.groupTopicID]);
  return (
    <BoxLayout margin={[0, 0, 0, 0]}>
      <Outlet
        context={{
          formData,
          setFormData,
          pathType,
          dataForUpdateGroupTopicByID,
          getAllTopics,
          setGetAllTopics,
          createGroupTopicEditPath,
          tenantName,
          createGroupTopicPath
        }}
      />
    </BoxLayout>
  );
};

export default CreateGroupTopic;
